exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (max-width: 400px) {\n.row > [class*=\"col-\"][data-v-26328166] {\n        padding-left: 0 px !important;\n        padding-right: 5px !important;\n}\n}\n", ""]);

// exports
